import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import 'normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './Button.css';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import Loader from 'react-loader-spinner'
import ProfilePage from "./pages/VideoPage";
import EnterPage from "./pages/EnterPage";
import Page404 from "./pages/Page404";
import {connect} from "react-redux";
import {auth} from "./reducers/profile/actions";

const PrivateRoute = ({component: Component, ...rest}) => {
    return (
        <Route
            {...rest}
            render={() =>
                rest.user ? (
                    <Component/>
                ) : (
                    <Redirect to={"/login"} component={EnterPage}/>
                )
            }
        />
    );
};

const HomeRoute = ({component: Component, ...rest}) => {
    return (
        <Route
            {...rest}
            render={() =>
                rest.user ? (
                    <Redirect to={"/profile"}/>
                ) : (
                    <Component {...rest}/>
                )
            }
        />
    );
};

function App({history, user, isCheckedAuth, checkedAuth}) {
    const [isMounted, setMounted] = useState(false);

    useEffect(() => {
        if (!isMounted) {
            setMounted(true);
            checkedAuth();
        }
    });

    return (
        <BrowserRouter>
            {isCheckedAuth ? (<div>
                <Switch>
                    <PrivateRoute path="/profile" component={ProfilePage} user={user}/>
                    <HomeRoute exact path='/login' component={EnterPage} user={user}/>
                    <Redirect exact from='/' to="/login"/>
                    <Route component={Page404}/>
                </Switch>
            </div>) : <div style={{width: '100%', textAlign: 'center'}}>
                <Loader
                    type="Plane"
                    color="#f4ff02"
                    height="100"
                    width="100"
                />
            </div>}
        </BrowserRouter>
    )
}

App.propTypes = {
    history: PropTypes.object,
    user: PropTypes.object,
    isCheckedAuth: PropTypes.bool,
    checkedAuth: PropTypes.func,
};

export default connect(state => {
    const {
        profile: {
            user,
            isCheckedAuth,
        },
    } = state;
    return {
        user: user,
        isCheckedAuth,
    };
}, dispatch => {
    return {
        checkedAuth: () => dispatch(auth()),
    };
})(App);
